import { render } from "./Gsearch.vue?vue&type=template&id=5187a4eb&scoped=true"
import script from "./Gsearch.vue?vue&type=script&lang=js"
export * from "./Gsearch.vue?vue&type=script&lang=js"

import "./Gsearch.vue?vue&type=style&index=0&id=5187a4eb&scoped=true&lang=css"

import exportComponent from "/usr/local/share/application/bug-finder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5187a4eb"]])

export default __exports__